(() => {
  const normalize = (str) =>
    (str || "")
      .toString()
      .trim()
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "");

  /* Valores de opcao de variante que LIGAM os campos de personalizacao.
     A loja usa "Customize" (opcao "Add Name & Number"); os demais ficam por
     compatibilidade com a versao PT antiga e com traducao de mercado.
     A comparacao e por igualdade exata, entao "Don't Customize" NAO liga. */
  const VALORES_ATIVA = [
    "customize",
    "customise",
    "personalizar",
    "personalizacao",
    "com personalizacao",
    "sim",
    "yes",
  ];

  const ativaPersonalizacao = (variant) => {
    const options = Array.isArray(variant?.options) ? variant.options : [];
    return options.some((opt) => VALORES_ATIVA.indexOf(normalize(opt)) !== -1);
  };

  function getInitialVariantFromSection(productInfoEl) {
    const script = productInfoEl?.querySelector('variant-selects script[data-selected-variant]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Re-consulta o wrapper no DOM a cada uso: o Dawn substitui o HTML do
     product-info ao trocar de variante, e uma referencia guardada fica orfa. */
  function findWrapper(sectionId) {
    return document.querySelector(
      `[data-personalizacao-wrapper][data-section-id="${sectionId}"]`
    );
  }

  function togglePersonalizacao(wrapper, variant) {
    if (!wrapper) return;

    const campos = Array.from(wrapper.querySelectorAll("input, select, textarea"));

    if (ativaPersonalizacao(variant)) {
      wrapper.classList.remove("hidden");
      campos.forEach((campo) => {
        campo.disabled = false;
      });
    } else {
      wrapper.classList.add("hidden");
      campos.forEach((campo) => {
        campo.value = "";
        campo.disabled = true;
      });
    }
  }

  function initPersonalizacaoForProductInfo(productInfoEl) {
    const sectionId = productInfoEl?.dataset?.section;
    if (!sectionId) return;
    if (productInfoEl.dataset.persoInit === "1") return;
    productInfoEl.dataset.persoInit = "1";

    /* 1) estado inicial */
    togglePersonalizacao(findWrapper(sectionId), getInitialVariantFromSection(productInfoEl));

    /* 2) quando mudar variante (evento nativo do Dawn) */
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event?.data;
        if (!data || data.sectionId !== sectionId) return;
        togglePersonalizacao(findWrapper(sectionId), data.variant);
        /* reforco no frame seguinte, caso o re-render do Dawn chegue depois do evento */
        requestAnimationFrame(() =>
          togglePersonalizacao(findWrapper(sectionId), data.variant)
        );
      });
    }
  }

  const initAll = () => {
    document.querySelectorAll("product-info").forEach(initPersonalizacaoForProductInfo);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
